import { render, staticRenderFns } from "./ViewPurchaseInvoiceRow.vue?vue&type=template&id=253e6b7a"
import script from "./ViewPurchaseInvoiceRow.vue?vue&type=script&lang=ts"
export * from "./ViewPurchaseInvoiceRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports